var allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
    'Meta',
    'Control',
];
export var checkForLimit = function (e, length, limit) {
    var _a;
    var isSpecialKey = allowedKeys.includes(e.key);
    if (length >= limit && !isSpecialKey && !((_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString())) {
        e.preventDefault();
    }
};
